import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="relative z-10 border-t border-white/10 bg-[hsl(155,38%,4%)]">
      <div className="mx-auto max-w-[1600px] px-6 py-24 md:px-12 md:py-32">
        <Reveal>
          <p className="mb-8 font-mono text-xs uppercase tracking-[0.3em] text-primary">
            [ Let&apos;s coordinate your next build ]
          </p>
          <Link to="/contact" data-testid="footer-cta" className="group block">
            <h2 className="font-heading text-[16vw] font-black uppercase leading-[0.82] tracking-tighter transition-colors duration-500 group-hover:text-primary md:text-[11vw]">
              Let&apos;s talk
              <ArrowUpRight className="ml-2 inline-block h-[8vw] w-[8vw] align-top transition-transform duration-500 group-hover:translate-x-4 group-hover:-translate-y-4 md:h-[6vw] md:w-[6vw]" />
            </h2>
          </Link>
        </Reveal>

        <div className="mt-24 grid grid-cols-1 gap-10 border-t border-white/10 pt-12 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3">
              <span className="inline-block h-2.5 w-2.5 rotate-45 bg-primary" />
              <span className="font-heading text-lg font-extrabold uppercase tracking-tight">
                Prescience Service
              </span>
            </div>
            <p className="mt-4 max-w-sm font-mono text-sm leading-relaxed text-muted-foreground">
              International parts sourcing, consulting, and logistics coordination for engineering firms.
            </p>
          </div>

          <div>
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-white/50">Navigate</p>
            <ul className="mt-4 space-y-2 font-mono text-sm">
              <li><Link to="/" className="text-white/80 transition-colors hover:text-primary">Home</Link></li>
              <li><Link to="/about" className="text-white/80 transition-colors hover:text-primary">About</Link></li>
              <li><Link to="/contact" className="text-white/80 transition-colors hover:text-primary">Contact</Link></li>
            </ul>
          </div>

          <div>
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-white/50">Contact</p>
            <ul className="mt-4 space-y-2 font-mono text-sm">
              <li><a href="mailto:contact@prescience-svcs.com" className="text-white/80 transition-colors hover:text-primary">contact@prescience-svcs.com</a></li>
              <li className="text-white/80">5888 West Sunset Blvd.<br />Las Vegas, NV 89118</li>
              <li className="text-muted-foreground">Sourcing worldwide</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col justify-between gap-3 border-t border-white/10 pt-6 font-mono text-xs uppercase tracking-[0.15em] text-white/40 md:flex-row">
          <span>© {year} Prescience Service</span>
          <span>Global Operation, Simplified.</span>
        </div>
      </div>
    </footer>
  );
}
